import {Injectable} from '@angular/core';
import {MapSidebarFilter} from './map-sidebar-filter';
import {ReplaySubject, Subject} from 'rxjs';
import {Map} from 'leaflet';
import DxDataGrid from 'devextreme/ui/data_grid';

@Injectable({
  providedIn: 'root'
})
export class MapSidebarFilterService {


  private _filterSubject = new ReplaySubject<MapSidebarFilter>(1);
  filter$ = this._filterSubject.asObservable();

  visible: boolean;
  filter: MapSidebarFilter;

  groupByList = [
    {text: '(Tous)', value: 'none'},
    {text: 'Domaine', value: 'domain'},
    {text: 'Business Unit', value: 'bu'},
    {text: 'Business Unit et Domaine', value: 'both'},
  ];
  private key = 'map-sidebar-filter';

  constructor() {

    const raw = localStorage.getItem(this.key);

    this.filter = raw !== null ? MapSidebarFilter.fromJSON(raw) : new MapSidebarFilter();
    // Populate the first filter
    this._filterSubject.next(this.filter);
  }

  apply() {
    localStorage.setItem(this.key, JSON.stringify(this.filter));
    this._filterSubject.next(this.filter);
    this.hide();
  }

  reset() {
    this.filter = new MapSidebarFilter();
    localStorage.removeItem(this.key);
    this._filterSubject.next(this.filter);
    this.hide();
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  applyOnGrid(grid: DxDataGrid, baseFilters?: any) {
    grid.beginUpdate();

    // Apply domain id filter
    const allFilters = baseFilters ? [baseFilters] : [];
    if (this.filter.domains.length > 0) {
      const domainFilter = [];
      this.filter.domains.forEach(d => domainFilter.push(['domain_name', '=', d.name], 'or'));
      allFilters.push(domainFilter);
    }
    if (allFilters.length > 0) {
      grid.filter(allFilters);
    } else {
      grid.clearFilter();
    }

    // Grouping
    grid.clearGrouping();
    grid.clearSorting();
    switch (this.filter.groupBy) {
      case 'both':
        grid.columnOption('domain_name', {groupIndex: 1, sortIndex: 1});
        grid.columnOption('business_unit_name', {groupIndex: 0, sortIndex: 0});
        break;
      case 'bu':
        grid.columnOption('business_unit_name', {groupIndex: 0, sortIndex: 0});
        break;
      case 'domain':
        grid.columnOption('domain_name', {groupIndex: 0, sortIndex: 0});
        break;
      case 'none':
        break;
    }
    grid.endUpdate();
  }
}
